/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getEmployment} from '../api'

 export const useQueryGetEmployment = createReactQueryHook('getEmployment', getEmployment)
